/* eslint-disable import/prefer-default-export */

/**
 * run string through several find/replaces to remove potential html entities
 *
 * CLEANUP: take alternative approach here / make more generic
 *
 * @param {String}
 * @returns {String}
 *
 */
export function replaceDecimalCode(str) {
  return String(str)
    .replace(/&#0?38;/g, '&')
    .replace(/&#8221;/g, '”')
    .replace(/&#8220;/g, '“')
    .replace(/&#8216;/g, '‘')
    .replace(/&#8217;/g, '’')
    .replace(/&#0?39;/g, "'")
    .replace(/&#0?34;/g, '"')
    .replace(/&#0?40;/g, '(')
    .replace(/&#0?41;/g, ')');
}
